import React from 'react';
import { Flex, Spinner, Box } from '@chakra-ui/react';

interface LoaderOverlayProps {
  isOpen: boolean;
  isFullscreen?: boolean;
  parentRef?: React.RefObject<HTMLDivElement>;
}

const LoaderOverlay: React.FC<LoaderOverlayProps> = ({
  isOpen,
  isFullscreen = false,
  parentRef,
}) => {
  if (!isOpen) return null;

  return (
    <Box
      position={isFullscreen ? 'fixed' : 'absolute'}
      top={0}
      left={0}
      right={0}
      bottom={0}
      bg="rgba(0, 0, 0, 0.5)"
      display="flex"
      alignItems="center"
      justifyContent="center"
      zIndex={9999}
      style={
        !isFullscreen && parentRef?.current
          ? {
              top: `${parentRef.current.getBoundingClientRect().top}px`,
              left: `${parentRef.current.getBoundingClientRect().left}px`,
              width: `${parentRef.current.getBoundingClientRect().width}px`,
              height: `${parentRef.current.getBoundingClientRect().height}px`,
            }
          : {}
      }
    >
      <Spinner size="xl" color="primary.100" />
    </Box>
  );
};

export default LoaderOverlay;
